// 影视资讯示例数据（前端演示用）

export const newsList = [
  {
    id: 'n01',
    title: '《流光之城》口碑爆棚：为什么说它拍出了都市爱情最真实的底色',
    category: '影评',
    author: '影评人 · 沈砚',
    date: '2024-10-14',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20editorial%20image%20of%20a%20rainy%20city%20street%20at%20night%20with%20warm%20amber%20shop%20lights%20and%20reflections%2C%20moody%20romantic%20atmosphere%2C%20deep%20charcoal%20tones%2C%20no%20text%2C%20film%20still%20aesthetic%2C%20high%20detail&width=800&height=450&seq=hs-n01&orientation=landscape',
    summary: '上映两周，《流光之城》凭口碑持续逆跌。它没有把爱情拍成童话，而是拍成了一件需要勇气的事。',
    tags: ['流光之城', '都市爱情', '影评'],
    content: [
      '上映两周，《流光之城》的排片不升反降的情况下，票房却一路逆跌。这背后，是观众口口相传的一句评价：「它拍出了成年人的爱情。」',
      '影片里没有夸张的误会，也没有刻意的煽情。男女主角的每一次靠近，都伴随着现实的重量——房贷、加班、异地，以及那些说不出口的抱歉。导演顾棠用大量安静的镜头，把人与人之间的距离感拍得恰到好处。',
      '最打动人的，也许是那场深夜便利店的戏。两个人各自买了一罐热咖啡，坐在落地窗前，很久没有人先开口。城市的霓虹在玻璃上流动，那一刻的沉默比任何台词都更接近爱情本来的样子。',
      '当然，影片也并非没有争议。有观众认为后半段的节奏偏慢，线索收束得有些仓促。但更多人愿意为这份克制买单——在一个习惯用狗血刺激感官的时代，愿意慢慢讲一个故事的创作者，本身就值得被看见。',
      '如果你也在城市里认真生活过，大概会在某个镜头里，看到自己的影子。',
    ],
  },
  {
    id: 'n02',
    title: '2024 国庆档盘点：国产科幻与现实主义题材双双突围',
    category: '行业动态',
    author: '编辑部 · 陆行',
    date: '2024-10-11',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20editorial%20image%20of%20an%20empty%20elegant%20cinema%20hall%20with%20warm%20amber%20seat%20lights%20and%20a%20glowing%20screen%2C%20deep%20charcoal%20tones%2C%20atmospheric%20mood%20lighting%2C%20no%20text%2C%20film%20still%20aesthetic%2C%20high%20detail&width=800&height=450&seq=hs-n02&orientation=landscape',
    summary: '今年的国庆档呈现出清晰的「两极」格局：科幻大片与现实主义中小成本作品同时受到关注。',
    tags: ['国庆档', '票房', '行业'],
    content: [
      '为期七天的国庆档正式收官。据不完全统计，今年档期内新片数量创下近年新高，题材分布也明显更为多元。',
      '与往年由单一类型主导不同，今年最大的亮点是「两极开花」：一边是制作精良的国产科幻作品，用工业化水准撑起了档期的视觉天花板；另一边则是一批聚焦普通人生活的中小成本现实主义影片，用真诚赢得了口碑。',
      '有影评人指出，这种格局的变化说明观众的审美正在成熟。人们既愿意为大银幕上的奇观买单，也会为一句戳中心事的台词走进影院。',
      '值得注意的是，悬疑与犯罪类型依旧稳定输出，多部作品在社交平台引发推理讨论。而动画电影则继续扮演着合家欢的重要角色，撑起了下午场的主要人流。',
      '接下来的十一月，还有多部备受期待的作品蓄势待发。可以预见，年终的电影市场仍将热闹非凡。',
    ],
  },
  {
    id: 'n03',
    title: '专访《暗夜追凶》导演韩沉：悬疑的尽头，是对人的理解',
    category: '新片推荐',
    author: '特约记者 · 温言',
    date: '2024-10-09',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20editorial%20portrait%20scene%20of%20a%20foggy%20alley%20at%20night%20with%20a%20single%20warm%20amber%20street%20lamp%20and%20misty%20dark%20tones%2C%20mysterious%20moody%20atmosphere%2C%20no%20text%2C%20film%20still%20aesthetic%2C%20high%20detail&width=800&height=450&seq=hs-n03&orientation=landscape',
    summary: '在《暗夜追凶》票房走高之际，导演韩沉聊了聊他理解的悬疑：「谜题是壳，人心才是核。」',
    tags: ['暗夜追凶', '导演专访', '悬疑'],
    content: [
      '采访约在一间安静的剪辑室。韩沉刚从后期棚出来，桌上放着一摞被翻旧的分镜稿。',
      '「很多人以为悬疑片的核心是反转。但对我来说，反转只是给观众的一个惊喜，真正留住人的，是人物为什么这么做。」韩沉说。',
      '《暗夜追凶》里，凶手并不是最难解的题。真正让观众坐立不安的，是每个人物身上那点难以言说的灰色地带——正义与执念之间，其实只有一线之隔。',
      '谈到创作方法，韩沉提到自己有一个「细节本」，专门记录生活中被忽略的小动作。「电影的可信度，往往藏在这些不起眼的地方。观众也许说不出哪里好，但他们能感觉到真实。」',
      '当被问到是否担心被类型化时，他笑了笑：「拍什么类型不重要，重要的是你有没有想说的话。悬疑只是我选择的一种说话方式。」',
    ],
  },
  {
    id: 'n04',
    title: '《星河长明》迎大结局，开放式结尾引发观众两极讨论',
    category: '行业动态',
    author: '剧集观察 · 苏禾',
    date: '2024-10-13',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20editorial%20image%20of%20an%20ancient%20palace%20corridor%20lit%20by%20warm%20amber%20lanterns%20at%20night%20with%20mist%2C%20deep%20charcoal%20tones%2C%20moody%20atmospheric%20lighting%2C%20no%20text%2C%20film%20still%20aesthetic%2C%20high%20detail&width=800&height=450&seq=hs-n04&orientation=landscape',
    summary: '热播剧《星河长明》昨日收官，开放式结局让「他们到底有没有重逢」成为社交平台的热门话题。',
    tags: ['星河长明', '大结局', '讨论'],
    content: [
      '昨晚，陪伴观众一个多月的《星河长明》迎来大结局。结局播出后不久，「星河长明结局」便冲上热搜前列。',
      '与原著小说明确的团圆结局不同，剧版选择了一个开放式的处理：战争结束，山河重归安宁，但男女主角是否重逢，镜头并没有给出答案。',
      '支持者认为，这样的处理让整部剧的格局更大了——它讲的不只是一段感情，更是乱世中一代人的选择与牺牲。而反对者则觉得，追了这么久的观众，值得得到一个更明确的交代。',
      '主创团队在收官直播中回应：「我们想留下的，是一种回味。真正的好故事，会在观众心里继续生长。」',
      '无论争议如何，这部剧在制作水准、人物塑造上的用心，依然得到了广泛认可。它也再次证明：观众对好内容的耐心与热情，从未消失。',
    ],
  },
  {
    id: 'n05',
    title: '慢综艺为何越来越受欢迎？一份关于「松弛感」的观察',
    category: '行业动态',
    author: '综艺观察 · 林一',
    date: '2024-10-06',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20editorial%20image%20of%20a%20quiet%20coastal%20village%20at%20golden%20sunset%20with%20warm%20amber%20light%20and%20calm%20sea%2C%20deep%20charcoal%20shadows%2C%20serene%20peaceful%20mood%2C%20no%20text%2C%20film%20still%20aesthetic%2C%20high%20detail&width=800&height=450&seq=hs-n05&orientation=landscape',
    summary: '从《旅行的意义》到《环球美食纪》，没有强冲突的慢综艺，正成为许多观众的「下饭首选」。',
    tags: ['慢综艺', '旅行', '趋势'],
    content: [
      '不知从何时起，「下饭综艺」成了很多人生活里的固定节目。它们通常没有激烈的游戏对抗，也没有刻意的戏剧冲突，只是几个人一起做饭、聊天、看风景。',
      '这类被统称为「慢综艺」的节目，正在悄悄占据越来越多观众的观看时长。',
      '分析认为，慢综艺的走红，与当下观众的心理需求密切相关。在快节奏的都市生活里，人们需要一个可以放松下来、不必动脑的「情绪出口」。',
      '「看他们慢慢吃一顿饭，我好像也被治愈了。」一位观众在评论里写道。',
      '当然，慢并不意味着平庸。真正优秀的慢综艺，依然需要精良的拍摄、真诚的人物关系，以及对生活细节的敏锐捕捉。毕竟，让人放松和让人睡着，是两回事。',
    ],
  },
  {
    id: 'n06',
    title: '影评：《樱花之约》——一场关于错过与重逢的温柔叙事',
    category: '影评',
    author: '影评人 · 周叙',
    date: '2024-10-03',
    cover: 'https://readdy.ai/api/search-image?query=cinematic%20editorial%20image%20of%20cherry%20blossom%20trees%20in%20soft%20warm%20sunset%20light%20with%20petals%20drifting%20in%20the%20air%2C%20deep%20charcoal%20shadows%2C%20gentle%20nostalgic%20mood%2C%20no%20text%2C%20film%20still%20aesthetic%2C%20high%20detail&width=800&height=450&seq=hs-n06&orientation=landscape',
    summary: '没有惊天动地的情节，《樱花之约》只是安静地讲了一封信的故事，却让人在散场后久久不愿离开。',
    tags: ['樱花之约', '日韩电影', '影评'],
    content: [
      '《樱花之约》是一部需要耐心的电影。它的节奏舒缓得像春天的风，轻轻拂过，不留下太多声响。',
      '故事很简单：一封迟到五年的信，让两个曾经错过的人重新站在同一棵樱花树下。导演小林悠没有急于推进剧情，而是用大量留白，去描摹「等待」这件事本身的形状。',
      '片中最动人的，往往不是对白，而是那些静止的瞬间——一个人望着窗外发呆，一支烟燃到尽头，雨滴落在伞面上的声音。',
      '有人批评影片「太淡」，缺少戏剧张力。但在我看来，这种「淡」恰恰是它的力量所在。生活里大多数重要的时刻，本来就不是轰烈的，而是安静的、后知后觉的。',
      '如果你也有过一个没能好好告别的人，这部电影也许会让你在某个镜头里，轻轻想起他或她。',
    ],
  },
];

export const newsCategories = ['影评', '新片推荐', '行业动态'];